import React from 'react';

import { Box, SxProps } from '@mui/material';
import ReactImageMagnify from 'react-image-magnify';

// ********************************************************************************
type Props = { sx?: SxProps };
export const WheelsMap: React.FC<Props> = ({ sx }) => {
  return (
    <Box width={{ xs: '100%', md: '400px' }} sx={sx}>
      <ReactImageMagnify
        enlargedImagePosition="over"
        smallImage={{
          src: 'https://cbx-fe.s3.us-east-2.amazonaws.com/app/CBX-Map-Wheels.svg',
          isFluidWidth: true,
        }}
        largeImage={{
          src: 'https://cbx-fe.s3.us-east-2.amazonaws.com/app/CBX-Map-Wheels.svg',
          width: 400 * 3,
          height: 600 * 3,
        }}
      />
    </Box>
  );
};
